//se importan los componentes de MUI 
import { Alert, AlertColor, Snackbar, Typography } from "@mui/material";
//se importa a React
import React from "react";

//se tipea un objeto que contiene las propiedades de la notificación
type NotificationProps = {
    //si está desplegada la notificación
    open:boolean;
    //el mensaje que dirá
    msg:string;
    //color de la notificación
    severity:AlertColor | undefined;
    //cerrar la notificación
    handleClose:() => void;
}

//componente de notificación que se le pasa el objeto NotificationProps y los mismos parámetros 
export const Notification: React.FC<NotificationProps> = ({
    open,
    msg,
    severity,
    handleClose
    }) =>{
    return(
        //snackbar es la notificación
        <Snackbar 
        //lugar donde aparecerá (arriba en el centro)
        anchorOrigin={{vertical:"top",horizontal:"center"}} 
        //tiempo de duración de la notificación
        autoHideDuration={4000}
        //estatus de abierto
        open={open}
        //modo de cerrado
        onClose={handleClose}
        >
            <Alert onClose={handleClose} severity={severity}>
                <Typography>{msg}</Typography> 
            </Alert>
        </Snackbar>
    );
};